import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/index.css";
import "./assets/tailwind.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import ru from "element-plus/es/locale/lang/ru";
import { initTheme } from "@/services/theme";
import { notify } from "@/services/notify";
import { domain, apiClient } from "@/api/api-client";

initTheme();

window.domain = domain;
window.apiClient = apiClient;

const app = createApp(App).use(store).use(router).use(ElementPlus, {
  locale: ru,
});

// Route Element-Plus-style $message calls through vue-sonner toasts
app.config.globalProperties.$message = notify;

app.mount("#app");
